import { useUpdate } from "@refinedev/core";
import { Send } from "@/components/ui/icon";
import type { Package } from "@aos/shared";

import { Button } from "@/components/ui/button";
import { PackageInspectorShow } from "@/resources/packages/PackageInspectorShow";

/**
 * Bet detail — the shared Inspector grammar over a `package_type='bet'` record,
 * with the Bet-specific **request review** primary action (`PATCH status` →
 * `review`, the governance gate from frontend-entity-coverage §2.2).
 */
export function BetShow() {
  return (
    <PackageInspectorShow
      resource="bets"
      dataResource="packages"
      expectType="bet"
      label="Bet"
      subtitle="A strategic bet that prioritizes which contours and skills to invest in."
      primaryAction={(pkg, refresh) => <RequestReview pkg={pkg} onDone={refresh} />}
    />
  );
}

/** PATCHes a bet to `status='review'` via the boxed Refine dataProvider. */
function RequestReview({ pkg, onDone }: { pkg: Package; onDone: () => void }) {
  const { mutate, isLoading } = useUpdate();
  if (pkg.status === "review") return null;
  return (
    <Button
      size="sm"
      disabled={isLoading}
      data-testid="bet-request-review"
      onClick={() =>
        mutate(
          { resource: "packages", id: pkg.id, values: { status: "review" } },
          { onSuccess: () => onDone() },
        )
      }
    >
      <Send className="mr-2 h-4 w-4" />
      {isLoading ? "Requesting…" : "Request review"}
    </Button>
  );
}

export default BetShow;
